<template>
    <div>
        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="15" :md="17">
                    <el-form-item>
                        <el-select @change="changeInstituicao" v-model="filtroInstituicao.id" filterable placeholder="Pesquisar Instituição">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-row :gutter="10" class="u-mt-10 u-mb-10">
            <el-col :xs="24" class="u-text-right">
                <el-button type="info" plain icon="el-icon-refresh" @click="load" :disabled="exibeSelectInstituicao && !filtroInstituicao.id">ATUALIZAR</el-button>
            </el-col>
        </el-row>

        <div v-if="exibeSelectInstituicao && !filtroInstituicao.id" class="u-text-center u-mt-25 u-text-muted">
            Selecione uma instituição para visualizar o dashboard.
        </div>

        <div v-if="!carregado && (!exibeSelectInstituicao || filtroInstituicao.id)" class="u-text-center u-mt-25">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <div v-if="carregado">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="6" :md="6">
                    <div class="card-dashboard">
                        <div class="card-title">Livros cadastrados</div>
                        <div class="card-value">{{ dados.total_livros }}</div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <div class="card-dashboard">
                        <div class="card-title">Total de exemplares</div>
                        <div class="card-value">{{ dados.total_exemplares }}</div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <div class="card-dashboard">
                        <div class="card-title">Empréstimos ativos</div>
                        <div class="card-value">{{ dados.emprestimos_ativos }}</div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <div class="card-dashboard alerta" :class="{ 'alerta-on': dados.emprestimos_atrasados > 0 }">
                        <div class="card-title">Empréstimos atrasados</div>
                        <div class="card-value">{{ dados.emprestimos_atrasados }}</div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mt-20">
                <el-col :xs="12" :sm="6" :md="6">
                    <div class="card-dashboard verde">
                        <div class="card-title">Disponíveis</div>
                        <div class="card-value">{{ dados.exemplares_disponiveis }}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="6" :md="6">
                    <div class="card-dashboard azul">
                        <div class="card-title">Emprestados</div>
                        <div class="card-value">{{ dados.exemplares_emprestados }}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="6" :md="6">
                    <div class="card-dashboard amarelo">
                        <div class="card-title">Danificados</div>
                        <div class="card-value">{{ dados.exemplares_danificados }}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="6" :md="6">
                    <div class="card-dashboard vermelho">
                        <div class="card-title">Perdidos / descartados</div>
                        <div class="card-value">{{ dados.exemplares_perdidos + dados.exemplares_descartados }}</div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mt-20">
                <el-col :xs="24">
                    <c-panel title="Top 5 livros mais emprestados" titleIcon="fas fa-trophy">
                        <table class="table table-striped" v-if="dados.top_livros_mais_emprestados && dados.top_livros_mais_emprestados.length">
                            <thead>
                                <tr>
                                    <th style="width: 40px;">#</th>
                                    <th>Título</th>
                                    <th>Autor</th>
                                    <th class="u-text-center" style="width: 160px;">Empréstimos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(livro, idx) in dados.top_livros_mais_emprestados" :key="livro.id">
                                    <td>{{ idx + 1 }}</td>
                                    <td>{{ livro.titulo }}</td>
                                    <td>{{ livro.autor }}</td>
                                    <td class="u-text-center"><strong>{{ livro.total_emprestimos }}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else class="u-text-center u-text-muted u-mt-15 u-mb-15">
                            Nenhum empréstimo registrado nesta instituição.
                        </div>
                    </c-panel>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mt-20">
                <el-col :xs="24">
                    <c-panel title="Relatórios" titleIcon="fas fa-file-export">
                        <el-row :gutter="10" class="u-mb-15">
                            <el-col :xs="24" :sm="6" :md="6">
                                <small>Período (livros mais emprestados)</small>
                                <el-date-picker v-model="filtros.de" type="date" placeholder="De" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <small>&nbsp;</small>
                                <el-date-picker v-model="filtros.ate" type="date" placeholder="Até" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <small>Aluno (histórico)</small>
                                <el-input v-model="filtros.aluno_id" placeholder="ID do aluno"></el-input>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <small>Formato</small>
                                <el-select v-model="filtros.formato" style="width: 100%;">
                                    <el-option label="EXCEL (.XLSX)" value="excel"></el-option>
                                    <el-option label="PDF" value="pdf"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-button type="primary" plain icon="el-icon-download" @click="baixarRelatorio('livrosMaisEmprestados')" style="width: 100%;">Livros mais emprestados</el-button>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-button type="warning" plain icon="el-icon-download" @click="baixarRelatorio('atrasados')" style="width: 100%;">Empréstimos atrasados</el-button>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-button type="info" plain icon="el-icon-download" @click="baixarRelatorio('acervo')" style="width: 100%;">Acervo por categoria</el-button>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-button type="success" plain icon="el-icon-download" @click="baixarRelatorio('historicoAluno')" style="width: 100%;" :disabled="!filtros.aluno_id">Histórico do aluno</el-button>
                            </el-col>
                        </el-row>
                    </c-panel>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        carregado: false,
        filtros: {
            de: '',
            ate: '',
            aluno_id: '',
            formato: 'excel'
        },
        filtroInstituicao: { id: '', nome: '' },
        dados: {
            total_livros: 0,
            total_exemplares: 0,
            exemplares_disponiveis: 0,
            exemplares_emprestados: 0,
            exemplares_danificados: 0,
            exemplares_perdidos: 0,
            exemplares_descartados: 0,
            emprestimos_ativos: 0,
            emprestimos_atrasados: 0,
            top_livros_mais_emprestados: []
        }
    }),
    computed: {
        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted(){
        if(this.$store.state.config.instituicao){
            this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
        if(!this.exibeSelectInstituicao || this.filtroInstituicao.id){
            this.load();
        }
    },
    methods: {
        async changeInstituicao(){
            if(this.exibeSelectInstituicao){
                await this.$store.dispatch('setInstituicao', this.filtroInstituicao.id);
            }
            this.load();
        },
        load(){
            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null;
            if(!instituicaoId){
                window.eventBus.$emit('alert', {msg: 'Selecione uma instituição para visualizar o dashboard.', type: 'warning'});
                return;
            }
            this.carregado = false;
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/biblioteca/dashboard/` + instituicaoId,
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.dados = response.data;
                this.carregado = true;
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        baixarRelatorio(tipo){
            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null;
            if(!instituicaoId && tipo !== 'historicoAluno'){
                window.eventBus.$emit('alert', {msg: 'Selecione uma instituição.', type: 'warning'});
                return;
            }

            let url;
            switch(tipo){
                case 'livrosMaisEmprestados':
                    url = `/api/biblioteca/relatorio/livrosMaisEmprestados/${instituicaoId}?formato=${this.filtros.formato}`;
                    if(this.filtros.de){ url += `&de=${this.filtros.de}`; }
                    if(this.filtros.ate){ url += `&ate=${this.filtros.ate}`; }
                    break;
                case 'atrasados':
                    url = `/api/biblioteca/relatorio/atrasados/${instituicaoId}?formato=${this.filtros.formato}`;
                    break;
                case 'acervo':
                    url = `/api/biblioteca/relatorio/acervo/${instituicaoId}?formato=${this.filtros.formato}`;
                    break;
                case 'historicoAluno':
                    if(!this.filtros.aluno_id){
                        window.eventBus.$emit('alert', {msg: 'Informe o ID do aluno.', type: 'warning'});
                        return;
                    }
                    url = `/api/biblioteca/relatorio/historicoAluno/${this.filtros.aluno_id}?formato=${this.filtros.formato}`;
                    break;
                default: return;
            }

            window.eventBus.$emit('loading', true);
            this.$axios.get(this.$store.state.config.baseUrlApi + url, this.$store.getters.getHeaderAuthExcel).then(response => {
                window.eventBus.$emit('loading', false);
                const blob = new Blob([response.data], { type: response.headers['content-type'] || (this.filtros.formato === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `biblioteca_${tipo}.${this.filtros.formato === 'pdf' ? 'pdf' : 'xlsx'}`;
                link.click();
                window.URL.revokeObjectURL(link.href);
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        }
    }
}
</script>

<style scoped>
.card-dashboard{
    background: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    padding: 14px;
}
.card-title{ font-size: 12px; color: #666; }
.card-value{ font-size: 22px; font-weight: 600; margin-top: 6px; }
.card-dashboard.verde{ border-left: 4px solid #67C23A; }
.card-dashboard.azul{ border-left: 4px solid #409EFF; }
.card-dashboard.amarelo{ border-left: 4px solid #E6A23C; }
.card-dashboard.vermelho{ border-left: 4px solid #F56C6C; }
.card-dashboard.alerta.alerta-on{ background: #fef0f0; border-color: #F56C6C; }
.card-dashboard.alerta.alerta-on .card-value{ color: #F56C6C; }
</style>
